import highcharts from "highcharts";

export const chartUtils = {
    methods: {
        chartToBlock(chart, localX, localY) {
            let svg = chart.chart.getSVG();
            svg = svg.replace(
                '<svg',
                '<g transform="translate(' + (localX) + ', ' + (localY) + ' )"'
            );
            svg = svg.replace('</svg>', '</g>');
            return svg;
        },
        mergeChartBlock(height, width, blockList) {
            return `<svg height="${height}" width="${width}" version="1.1" xmlns="http://www.w3.org/2000/svg"> ${blockList.join('')}</svg>`;
        },
        mergeTwoChartBlock(chartBlockList) {
            const a4_WIDTH = 793.7;
            const a4_HEIGHT = 1122.52;
            let block = "";
            for (let i = 0; i < chartBlockList.length; i++) {
                block += `<svg height="${a4_HEIGHT}" width="${a4_WIDTH}" version="1.1" xmlns="http://www.w3.org/2000/svg"> ${chartBlockList[i].join('')}</svg>`;
            }
            return block;
        },
        getChartHeight(chart) {
            let svg = chart.chart.getSVG();
            return +svg.match(
                /^<svg[^>]*height\s*=\s*\"?(\d+)\"?[^>]*>/
            )[1];
        },
        getChartWidth(chart) {
            let svg = chart.chart.getSVG();
            return +svg.match(
                /^<svg[^>]*width\s*=\s*\"?(\d+)\"?[^>]*>/
            )[1];
        },
        getMaxChartWidth(chartList) {
            let maxChartWidth = 0;
            chartList.forEach(chart => {
                let svg = chart.chart.getSVG(),
                    svgWidth = +svg.match(
                        /^<svg[^>]*width\s*=\s*\"?(\d+)\"?[^>]*>/
                    )[1];
                maxChartWidth = Math.max(maxChartWidth, svgWidth);
            })
            return maxChartWidth;
        },
        getMaxChartHeight(chartList) {
            let maxChartHeight = 0;
            chartList.forEach(chart => {
                let svg = chart.chart.getSVG(),
                    svgHeight = +svg.match(
                        /^<svg[^>]*height\s*=\s*\"?(\d+)\"?[^>]*>/
                    )[1];
                maxChartHeight = Math.max(maxChartHeight, svgHeight);
            })
            return maxChartHeight;
        },
        setMessage(x, y, px, message) {
            return `<text x="${x}" y="${y}" style="font-size:${px}; text-anchor=middle;">${message}</text>`;
        }

    }
}

